/**
 * Empty state component for data tables per BL-011.
 * Shows icon, heading, description, and optional action button.
 */

import type { ReactNode } from "react";
import { GlassCard } from "./glass-card";

interface EmptyStateProps {
  readonly icon: ReactNode;
  readonly heading: string;
  readonly description: string;
  readonly action?: ReactNode;
}

export function EmptyState({
  icon,
  heading,
  description,
  action,
}: EmptyStateProps) {
  return (
    <GlassCard className="text-center py-12">
      <div className="flex justify-center mb-4 text-sc-text-muted">{icon}</div>
      <h3 className="text-h3 font-display text-sc-navy mb-2">{heading}</h3>
      <p className="text-body-sm text-sc-text-muted max-w-sm mx-auto mb-4">
        {description}
      </p>
      {action && <div>{action}</div>}
    </GlassCard>
  );
}
